var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 3.00224C22.0424 3.67772 20.9821 4.19435 19.86 4.53224C19.2577 3.83975 18.4573 3.34894 17.567 3.12617C16.6767 2.9034 15.7395 2.95944 14.8821 3.2867C14.0247 3.61395 13.2884 4.19664 12.773 4.95596C12.2575 5.71528 11.9877 6.61458 12 7.53224V8.53224C10.2426 8.57781 8.50127 8.18806 6.93101 7.39769C5.36074 6.60732 4.01032 5.44088 3 4.00224C3 4.00224 -1 13.0022 8 17.0022C5.94053 18.4002 3.48716 19.1012 1 19.0022C10 24.0022 21 19.0022 21 7.50224C20.9991 7.2237 20.9723 6.94584 20.92 6.67224C21.9406 5.66574 22.6608 4.39496 23 3.00224V3.00224Z",
    stroke: "#28245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlue);
export default __webpack_public_path__ + "static/media/twitter-blue.663f524c769e7656045928ec46ac92a4.svg";
export { ForwardRef as ReactComponent };